import { QueryKey, QueryObserver, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { UsageChartData } from 'src/common/utils/mapUsageDTOtoAreaChartData';

export const useHasUsageChartData = (queryKey: QueryKey) => {
  const [hasData, setHasData] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    const observer = new QueryObserver(queryClient, {
      queryKey,
    });
    const unsubscribe = observer.subscribe((result) => {
      const queryResult = result.data as UsageChartData;
      setHasData(!!queryResult?.data?.length);
    });

    return unsubscribe;
  }, []);

  return hasData;
};
